import { type } from '@/utils/type'

export const SOCKET_ONOPEN = type('SOCKET_ONOPEN')
export const SOCKET_ONCLOSE = type('SOCKET_ONCLOSE')
export const SOCKET_ONERROR = type('SOCKET_ONERROR')
export const SOCKET_ONMESSAGE = type('SOCKET_ONMESSAGE')
export const SOCKET_RECONNECT = type('SOCKET_RECONNECT')
export const SOCKET_RECONNECT_ERROR = type('SOCKET_RECONNECT_ERROR')
export const SOCKET_SENDMESSAGE = type('SOCKET_SENDMESSAGE')
export const SOCKET_ONKEEPALIVE = type('SOCKET_ONKEEPALIVE')

